import React from "react";

const HorizontalLineChart = ({ value = 32, width = 140, thickness = 4 }) => {
  const safeValue = isNaN(value) ? 0 : value;
  const maxHours = 40;
  const percent = Math.min(safeValue / maxHours, 1);
  const lineWidth = width * percent;

  let chartColor = "#32CD32"; // green
  if (safeValue <= 5) chartColor = "#DC143C"; // red
  else if (safeValue > 5 && safeValue < 20) chartColor = "#FFBF00"; // yellow

  const borderRadius = thickness / 2;

  return (
    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
      {/* Line chart with rounded corners */}
      <div
        style={{
          width: `${width}px`,
          height: `${thickness}px`,
          backgroundColor: "#e6e6e6",
          position: "relative",
          borderRadius: `${borderRadius}px`,
          overflow: "hidden",
        }}
      >
        <div
          style={{
            width: `${lineWidth}px`,
            height: "100%",
            backgroundColor: chartColor,
            borderRadius: `${borderRadius}px`,
            transition: "width 0.3s ease",
          }}
        />
      </div>
    </div>
  );
};

export default HorizontalLineChart;
